<template>
  <div class="save-configure-container">
    <ResponsiveButton
      :display_name="'Save Configuration'"
      :button_type="'filled'"
      :disabled="disabled"
      :built_in_theme="'dark'"
      size="small"
      width_type="fill-whole"
      classs="save-configure-button"
      @click-button="saveConfiguration"
    >
      <template #prefix>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.59016 13C10.1402 13 10.5902 13.45 10.5902 14C10.5902 14.55 10.1402 15 9.59016 15C9.04016 15 8.59016 14.55 8.59016 14C8.59016 13.45 9.04016 13 9.59016 13ZM9.59016 11C7.93016 11 6.59016 12.34 6.59016 14C6.59016 15.66 7.93016 17 9.59016 17C11.2502 17 12.5902 15.66 12.5902 14C12.5902 12.34 11.2502 11 9.59016 11ZM18.0902 9L19.1802 6.59L21.5902 5.5L19.1802 4.41L18.0902 2L17.0002 4.41L14.5902 5.5L17.0002 6.59L18.0902 9ZM20.8702 12.72L20.0902 11L19.3102 12.72L17.5902 13.5L19.3102 14.28L20.0902 16L20.8702 14.28L22.5902 13.5L20.8702 12.72ZM15.8402 14C15.8402 13.88 15.8402 13.75 15.8302 13.63L17.7702 12.16L15.2702 7.83L13.0302 8.77C12.8302 8.64 12.6102 8.51 12.3902 8.4L12.0902 6H7.09016L6.79016 8.41C6.57016 8.52 6.36016 8.65 6.15016 8.78L3.91016 7.83L1.41016 12.16L3.35016 13.63C3.34016 13.75 3.34016 13.88 3.34016 14C3.34016 14.12 3.34016 14.25 3.35016 14.37L1.41016 15.84L3.91016 20.17L6.15016 19.23C6.35016 19.36 6.57016 19.49 6.79016 19.6L7.09016 22H12.0902L12.3902 19.59C12.6102 19.48 12.8202 19.36 13.0302 19.22L15.2702 20.16L17.7702 15.83L15.8302 14.36C15.8402 14.25 15.8402 14.12 15.8402 14ZM14.4202 17.64L12.6902 16.91C12.1302 17.51 11.3902 17.95 10.5602 18.14L10.3202 20H8.86016L8.63016 18.14C7.80016 17.95 7.06016 17.51 6.50016 16.91L4.77016 17.64L4.04016 16.37L5.53016 15.24C5.41016 14.85 5.35016 14.44 5.35016 14.01C5.35016 13.58 5.41016 13.17 5.53016 12.78L4.04016 11.65L4.77016 10.38L6.50016 11.11C7.06016 10.51 7.80016 10.07 8.63016 9.88L8.86016 8H10.3302L10.5602 9.86C11.3902 10.05 12.1302 10.49 12.6902 11.09L14.4202 10.36L15.1502 11.63L13.6602 12.76C13.7802 13.15 13.8402 13.56 13.8402 13.99C13.8402 14.42 13.7802 14.83 13.6602 15.22L15.1502 16.35L14.4202 17.64Z" fill="white"/>
        </svg>
      </template>
    </ResponsiveButton>
  </div>
</template>

<script>
export default {
    props:{
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      saveConfiguration() {
        this.$emit('save-configuration');
      }
    }
}
</script>

<style scoped>
/* SaveConfigure now uses ResponsiveButton from va-responsive-components-library */
/* No custom styles needed - library component handles all styling */
.save-configure-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.save-configure-container :deep(.prefix-wrapper) {
  padding: 1px;
}
</style>  